import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';



@Component({
  selector: 'app-profile-opened',
  templateUrl: './profile-opened.component.html',
  styleUrls: ['./profile-opened.component.css']
})
export class ProfileOpenedComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  userID = this.route.snapshot.params.userID;
  openingID = this.route.snapshot.params.openingID;
  type = this.route.snapshot.params.type;
  currentUserId = this.authService.getTokenData().userID;
  isValid = false;
  applicants = [];
  opening;
  wellfareAreas = [];
  contacted_by = [];
  prices;

  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit(): void {
    console.log(this.type)
    if(this.type == 'application'){
      this.fetchOpening();
    }
    else if(this.type == 'businessInterest'){
      this.type = 'application';
      this.fetchPublicProfile();
    }
    else if(this.type == 'wishlist'){
      this.fetchWishlist();
    }

    //If locastorage dont have wellfareAreas then we have to fetch wellfareAreas
    if(!localStorage.getItem('wellfareAreas')){
      this.fetchWellfareAreas();
    }
    else{
      this.wellfareAreas = JSON.parse(localStorage.getItem('wellfareAreas'));
    }
    
  }

  fetchOpening(){

    var req = {
      businessID: this.businessID,
      openingID: this.openingID
    }

    this.http.post(environment.VALIDATE_OPEN_PROFILE + '/' + this.userID, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          var opening = res.message;
          this.fetchContacted('application', req.openingID)
  
          this.isValid = true;
          console.log('opening', opening)
          //this.selectBG(opening.profile.mdType.id, opening);

        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }

  fetchContacted(type, id){

    var req = {
      businessID: this.businessID,
      id: id,
      type: type,
      userID: this.userID,
    }
    console.log(req);



    this.http.post(environment.MESSAGES_CONTACTED_BY, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.contacted_by = res.message;
          console.log(this.contacted_by)


        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }

  fetchPublicProfile(){


    this.http.get(environment.VALIDATE_HEADHUNTING_PROFILE + '/' + this.userID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          var obj = {
            profile: res.message
          }
          this.opening = obj;

          console.log(res.message, this.opening.profile)
          
          this.isValid = true;
        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }

  openProfileConfirm(){
    
    //Fetch formed prices
    this.http.get(environment.EMPLOYER_PRICING, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {

          this.prices = res.message;
          console.log(this.prices);


          //Open modal
          document.getElementById('open-profile-btn').click();
          this.fetchWishlist();

        }
        else {

        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  

  }

  openProfile(){
    var req = {
      userID: this.userID,
      wishListID : this.route.snapshot.params.openingID,
      type: 'wishlist_profile_opening'
    }


    this.http.post(environment.OPEN_WHISLIST_PROFILE, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          //Close modal
          document.getElementById('close-modal-open').click();
          //
        }
        else {
          console.log('buu')
        }
        
      }, (err: any) => {

      }
    )
  }

  fetchWishlist(){
    console.log('wishlist')
    var req = {
      businessID: this.businessID,
      wishListID: this.openingID
    }

    this.http.post(environment.VALIDATE_WISHLIST_OPEN + '/' + this.userID, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          var opening = res.message
          this.fetchContacted('wishlist', req.wishListID)
          
          if(opening.wellfareAreas.length > 0){
            for (let i = 0; i < opening.wellfareAreas.length; i++) {
              var wf = opening.wellfareAreas[i];

              for (let j = 0; j < this.wellfareAreas.length; j++) {
                const elm = this.wellfareAreas[j];

                if(wf == elm.id){
                  console.log(elm);
                  opening.wellfareAreas[i] = elm;
                }
                
              }
            }
          }
          else{
            console.log('no wellfare areas')
          }

          console.log('opening', opening)
          this.opening = opening;

          //this.selectBG(opening.mdTypeID,opening);
          this.opening = opening;

          this.isValid = true;
        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }

  selectBG(mdtype,opening){

    console.log(mdtype, 'mdtype')

    switch (mdtype) {
      case 1001:
        console.log('1001')
        opening['bgimg'] = 'bg_doctor';
        opening['border-color'] = 'border-doctor'
        break;
      case 1002:
        console.log('1002')
        opening['bgimg'] = 'bg_doctor';
        opening['border-color'] = 'border-doctor'
        break;
      case 1003:
        opening['bgimg'] = 'bg_nurse';
        opening['border-color'] = 'border-nurse'
        break;
      case 1004:
        opening['bgimg'] = 'bg_nurse';
        opening['border-color'] = 'border-nurse'
        break;
      case 1005:
        opening['bgimg'] = 'bg_dentist';
        opening['border-color'] = 'border-dentist'
        break;
      case 1006:
        opening['bgimg'] = 'bg_dentist';
        opening['border-color'] = 'border-dentist'
        break;
      case 1008:
        opening['bgimg'] = 'bg_dentist';
        opening['border-color'] = 'border-dentist'
        break;
      case 10010:
        opening['bgimg'] = 'bg_student';
        opening['border-color'] = 'border-student'

        break;
      default:
        break;
    }

    this.opening = opening;
    console.log(this.opening)
}

  startMessaging(){

  }

  openCity(evt, cityName) {
    // Declare all variables
    var i, tabcontent, tablinks;

  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
  
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
  
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";

  
  
    }

    fetchWellfareAreas(){
      this.http.get(environment.PARAMS_WELLFAREAREAS, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            this.wellfareAreas = res.message['wellfare-areas'];
            localStorage.setItem('wellfareAreas', JSON.stringify(this.wellfareAreas));
          }
          else {
            console.log('buu')
          }
          
        }, (err: any) => {
  
        }
      )
    }

    sendMessage(){

      var openingMdType;
      var profilePicture;


      if(this.route.snapshot.params.type == 'wishlist'){
        openingMdType = this.opening['profile']['mdType'];
        profilePicture = this.opening['profile']['profilePicture'];

      }
      else if(this.route.snapshot.params.type == 'businessInterest'){
        openingMdType = this.opening.mdType;
        profilePicture = this.opening.profilePicture;
      }
      else{
        openingMdType = this.opening.mdType.name_fi;
        profilePicture = this.opening.profile.profilePicture;
      }




      var req = {
        openingID: this.openingID,
        firstName: this.opening.profile.firstName,
        mdType: this.opening.profile.mdType,
        logo: this.opening.logo,
        userID: this.userID,
        openingMdType: openingMdType,
        type: this.route.snapshot.params.type,
        businessID: this.businessID,
        profilePicture: profilePicture,
      }

      this.http.post(environment.MESSAGE_LIST, req, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            console.log(res);
            this.routeMessages(res.message[0]._id)
          }
          else {
            console.log('buu')
          }
          
        }, (err: any) => {
  
        }
      )
    }

    goBack(){
      window.history.back();
    }

    routeMessages(id){
      console.log(id);
      localStorage.setItem('ACTIVE_MSG_LIST', JSON.stringify(id));
      this.router.navigate([ '/'+this.businessID+'/messages']);
    }


}
